import { render, staticRenderFns } from "./fileTabCard.vue?vue&type=template&id=cd889282&scoped=true&"
import script from "./fileTabCard.vue?vue&type=script&lang=ts&"
export * from "./fileTabCard.vue?vue&type=script&lang=ts&"
import style0 from "./fileTabCard.vue?vue&type=style&index=0&id=cd889282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd889282",
  null
  
)

export default component.exports